import CKYCContainer from "containers/jarivsPrime/PrimeCKYC";
import React from "react";

const PrimeCKYC = (props) => {
  return (
    <>
      <CKYCContainer />
    </>
  );
};

export default PrimeCKYC;
